export default __webpack_public_path__ + "static/media/user-icon.41856725.png";